// imports
import { couponsCarouselJQuery } from "../../utilities/carouselSlickConfig";
import {BRAND_COL, BRAND_NAME_COL, BRAND_ZU, BRAND_NAME_ZU } from "../../utilities/constants";

// module cache
let carouselComponentModuleCache = {
    allSelected: false,
    allCachedCoupons: [],
    allActiveCoupons: []
};

/**
 * Get the brand ID from the item
 * @param {Object} item - The item to get the brand ID from
 * @returns {String} The brand ID
 */
function getBrandID(item) {
    if (!item) {
        return null;
    }

    if (item.brand == BRAND_NAME_COL) {
        return BRAND_COL;
    } else if (item.brand == BRAND_NAME_ZU) {
        return BRAND_ZU;
    } else {
        return "";
    }
}

/**
 * Get the badge icon name based on the brand and subBrand returned by CLL
 * @param {string} brand - The brand name
 * @param {string} subBrand - The subBrand name
 * @returns {string} - The badge icon name
 */
function getBadgeIconName(brand, subBrand) {
    const defaultIcon = "iconContinente";
    const badgeIconMapping = {
        "continente": {
            "continente": defaultIcon,
            "colzero": "iconContinenteEntregaZero",
            "exclusivoOnline": "iconContinenteExclusivoOnline",
            "pay": "iconContinentePay"
        },
        "zu": {
            "zu": "iconZu",
            "exclusivoonline": "iconZuExclusivoOnline"
        }
    };

    const normalizedBrand = brand.trim().toLocaleLowerCase();
    const normalizedSubBrand = subBrand ? subBrand.trim().toLocaleLowerCase() : normalizedBrand;

    return badgeIconMapping[normalizedBrand]?.[normalizedSubBrand] ?? defaultIcon;
}

/**
 * Generate the header for the carousel
 * @param {object} data - The data object
 * @returns {string} - The header for the carousel
 */
function getCarouselHeader(data) {
    return  `
        <div class="coupons-carousel-header">
            <div class="d-flex align-items-center justify-content-between coupons-carousel-subtitle-div px-3 px-sm-0 mb-2">
                <h3 class="coupons-carousel-title d-flex pwc-font--primary-bold m-0"><span class="d-none d-sm-block mr-1">${data.resources ? data.resources.couponsSubtitleDektop : ""}</span>${data.resources ? data.resources.couponsSubtitle : ""}</h3>
                <div class="d-flex align-items-center justify-content-between">
                    <div class="select-all-checkbox pwc-form-checkbox">
                        <input type="checkbox"
                            id="select-all-coupon-tiles"
                            class="select-all-coupon-tiles"
                            name="select-all-coupon-tiles"
                        />
                        <span class="checkmark"></span>
                        <label class="pwc-form-check-label" for="select-all-coupon-tiles">
                            ${data.resources.selectAll}
                        </label>
                    </div>
                </div>
            </div>
            <input type="checkbox"
                id="js-trigger-checkbox"
                class="d-none"
                name="trigger-checkbox"
            />
            <input type="hidden"
                id="js-trigger-checkbox"
                class="d-none js-delete-coupon-confirmation"
                name="trigger-checkbox"
                value=${data.resources.removeCustomerBenefits}
            />
        </div>`;
}

/**
 * Generates the discount template for the item
 * @param {Object} item - The item object
 * @returns {string} - The discount template
 */
function getDiscountTemplate(item) {
    let template = `
        <div class="ct-cart--coupon-badge-value-wrapper
            ${item.imageURL.discountObject && item.imageURL.discountObject.decimalsValue ? "ct-cart--coupon-badge-value-has-super-decimals" : ""}
            ${getBrandID(item) + "-cart--coupon-badge-value-wrapper"}">
            <span class="ct-cart--coupon-badge-value ${getBrandID(item) + "-cart--coupon-badge-value"}">
                ${item.imageURL.discountObject && item.imageURL.discountObject.decimalsValue ?
        `<span class="d-flex justify-content-center">
                        ${item.imageURL.discountObject.integerValue}
                        <span class="ct-cart--coupon-badge-value-quantifier ${getBrandID(item) + "-cart--coupon-badge-value-quantifier"}">
                            ${item.imageURL.unit}
                        </span>
                    <span class="ct-cart--coupon-badge-value-super-decimals">
                        ${item.imageURL.discountObject.decimalsValue}
                    </span>
                    </span>`
        :
        `<span>
                        ${item.imageURL.discount}
                        <span class="ct-cart--coupon-badge-value-quantifier ${getBrandID(item) + "-cart--coupon-badge-value-quantifier"}">
                            ${item.imageURL.unit}
                        </span>
                    </span>`
}
            </span>
        </div>`;
    return template;
}

/**
 * Builds the coupon element
 * @param {Object} data - The data object
 * @returns {string} - The coupon element
 */
function buildCouponElement(data) {
    let items = data.items;
    let coupons = "";
    for (let index = 0; index < items.length; index++) {
        const item = items[index];
        const itemID = item.giftId || item.voucherId;
        let iconName = getBadgeIconName(item.brand, item.subBrand);
        let svgIcon = data[iconName] ? data[iconName] : "";
        coupons += `<div class="ct-cart--coupon-tile coupon-tile cart-coupon-tile text-center js-brand-element-${getBrandID(item)}" data-brand=${getBrandID(item)}>
        <div class= "coupon-tile-topborder"></div>
        <div class= "context-coupon w-100 h-100">
            <div class="ct-cart--coupon-check coupon-checkbox pwc-form-checkbox pull-right">
                <input type="checkbox" id="${"coupon-" + itemID}"
                    value=${itemID}
                    data-type="gift"
                    data-description="${item.message}"
                    data-amount=${item.value}
                    data-unit=${item.unit}
                    data-is-carousel="true"
                    class="coupon-carousel-input"
                    name=${"coupon-" + itemID}
                    title
                />
                <label class="pwc-form-check-label" for="${"coupon-" + itemID}"></label>
                <span class="checkmark"></span>
                <input type="hidden" class="select-cached-coupon-tiles js-select-cached-coupon-tiles" />
            </div>
            <div class="subBrand d-none d-sm-block">
                ${svgIcon}
            </div>
            <div class="ct-cart--coupon-image-container d-flex justify-content-center">
                    <img class="ct-cart--coupon-image img-fluid"
                        src=${item.imageURL.url || item.imageURL.fallbackImage}
                        data-src=${item.imageURL.url || item.imageURL.fallbackImage}
                        alt="${item.brand}"
                        title="${item.brand}"
                    >
                    ${getDiscountTemplate(item)}
                </div>
                <div class="ct-cart--coupon-details details-expanded">
                    <div class="subBrand d-block d-sm-none">
                        ${svgIcon}
                    </div>
                    <div class="pwc-cart--coupon-description">
                        <span>
                            ${item.message}
                        </span>
                    </div>
                    <div class="ct-cart--coupons-bottom-details d-sm-block">
                        <div class="ct-cart--coupon-availability">
                            ${item.availabilityMessage}
                        </div>
                        <div class="ct-cart--coupon-id">
                            <span>
                                ${itemID}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
    }
    return coupons;
}

/**
 * Renders the carousel template
 * @param {Object} $ele - The element to render the template
 * @param {Object} data - The data to render the template
 */
function renderCarouselTemplate($ele, data) {
    $ele.append(`<div class="coupons-carousel-container">
                <div class="w-100">
                    <form class="coupons-grid-wrapper coupon-carousel-form" id="coupon-carousel-form" name="coupon-carousel-form" action="${data.resources.applyCustomerBenefits}">
                        ${getCarouselHeader(data)}
                        <div class="pwc-cart-coupons-carousel">${buildCouponElement(data)}</div>
                    </form>
                </div>
            </div>`);

    const carouselTypeConfig = couponsCarouselJQuery(data.itemsNumber, BRAND_COL);
    $(".pwc-cart-coupons-carousel").slick(carouselTypeConfig);

    const couponsCarouselTrack = document.querySelector(".coupons-grid-wrapper .slick-track");
    if (couponsCarouselTrack) {
        // Toggle the class based on the number of child elements
        const hasLessThanFourCoupons = couponsCarouselTrack.childElementCount < 4;
        couponsCarouselTrack.classList.toggle("less-than-four-coupons", hasLessThanFourCoupons);

        // If the class exists, change the display property of .slick-slider
        const couponsSlider = document.querySelector(".coupons-grid-wrapper .slick-slider");
        if (couponsSlider) {
            couponsSlider.style.display = hasLessThanFourCoupons ? "block" : "flex";
        }
    }
}

/**
 * Creates error template
 * @param {jQuery} $ele element to append
 * @param {Object} data data from response
 */
function renderErrorTemplate($ele, data) {
    return $ele.append(`<div class="coupons-carousel-container">
                <div class="w-100">
                    ${data.resources.notAvailableCouponsMessage}$
                </div>
            </div>`);
}

/**
  * Set in cache current value from select all checkbox ("TODOS")
  * @param {boolean} isChecked - boolean that represents the value of "TODOS" checkbox
  */
function setIsAllSelected(isChecked) {
    carouselComponentModuleCache.allSelected = isChecked;
}

/**
  * Get from cache current value from select all checkbox ("TODOS")
  */
function getIsAllSelected() {
    return carouselComponentModuleCache.allSelected;
}

/**
  * Saves coupons in cache from current brand
  * @param {string} selectedCoupons - Coupos selected by the user
  */
function setCachedCouponsSelected(selectedCoupons) {
    carouselComponentModuleCache["allActiveCoupons"] = selectedCoupons;
}

/**
  * Gets coupons in cache 
  */
function getCachedCouponsSelected() {
    return carouselComponentModuleCache["allActiveCoupons"];
}

/**
  * Saves all coupons in cache
  * @param {string} availableCoupons - Coupons returned by the service
  */
function setAllCachedCoupons(availableCoupons) {
    carouselComponentModuleCache["allCachedCoupons"] = availableCoupons;
}

/**
  * Get all coupons in cache
  */
function getAllCachedCoupons() {
    return carouselComponentModuleCache["allCachedCoupons"];
}

/**
  * Delete coupon from cache
  * @param {string} removedCoupon - coupon to be removed
  */
function removeCouponFromCache(removedCoupon) {
    if (!removedCoupon) return;
    // se for continente, temos que ir remover a todos
    let getCachedValue = getCachedCouponsSelected() || [];

    // remove duplicates
    let auxArray = removeDuplicates(getCachedValue);

    if (auxArray.length > 0) {
        const index = auxArray.indexOf(removedCoupon);
        if (index > -1) { // only splice array when item is found
            auxArray.splice(index, 1); // 2nd parameter means remove one item only
        }
        carouselComponentModuleCache["allActiveCoupons"] = auxArray;
    }
    setIsAllSelected(false);
}

/**
  * Function that saves in cache the selected coupons
  * @param coupon coupon to be saved in cache
  */
function saveSelectedCouponInCache(coupon) {
    // get current cached values
    let cachedValues =  getCachedCouponsSelected() || [];
    // append new values
    cachedValues.push(coupon);
    // remove duplicates
    let auxArray = removeDuplicates(cachedValues);
    // save in cache
    setCachedCouponsSelected(auxArray);
}

/**
  * Function that saves in cache the selected coupons
  */
function saveSelectedCoupons() {
    const $allCouponsChecked = $(".pwc-cart-coupons-carousel input[type=checkbox]");
    let selectedCoupons = [];
    $allCouponsChecked.each(function () {
        if ($(this).is(":checked")) {
            // push those that are selected
            selectedCoupons.push($(this).attr("name"));
        }
    });

    // get current cached values
    let cachedValues =  getCachedCouponsSelected() || [];
    // append new values
    let auxArray = cachedValues.concat(selectedCoupons);
    // remove duplicates
    auxArray = removeDuplicates(auxArray);
    // save in cache
    setCachedCouponsSelected(auxArray);
}

/**
  * Function that removes duplicate values from array
  * @param arr Array with duplicate valyes
  * @returns array without duplicate values
  */
function removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
}

export { renderErrorTemplate, renderCarouselTemplate, getCarouselHeader, setIsAllSelected, getIsAllSelected, setCachedCouponsSelected, saveSelectedCoupons, removeCouponFromCache, setAllCachedCoupons, getAllCachedCoupons, getCachedCouponsSelected, saveSelectedCouponInCache, removeDuplicates };
